import api from "./axios";

export const AdminCreditTransactionsAPI = {
  list: async ({ limit = 50, offset = 0, q = "", userId = "", reservationId = "", txType = "" } = {}) => {
    const params = { limit, offset };
    if (q) params.q = q;
    if (userId !== "" && userId !== null && userId !== undefined) params.user_id = userId;
    if (reservationId !== "" && reservationId !== null && reservationId !== undefined) params.reservation_id = reservationId;
    if (txType) params.tx_type = txType;

    const res = await api.get("/admin/credit-transactions", { params });
    return res.data;
  },
};
